import { BaseContainerModel } from '../../base-container.model';
import { bl_bi_report_query_run_hdr_RowClass } from '../../../dbschema';

export class QueryRunHdrModel extends BaseContainerModel {
  bl_bi_report_query_run_hdr: bl_bi_report_query_run_hdr_RowClass = new bl_bi_report_query_run_hdr_RowClass();
}
